<template>
  <div class="field filter-field">
    <label class="label heading-4 is-lighter">{{label}}</label>
    <b-select
      placeholder="placeholder"
      v-model="localSelectedCategories"
    >
      <option
        value
        selected
      >{{placeholder}}</option>
      <option
        v-for="category in categories"
        :value="category.id"
        :key="category.id"
      >{{ category.title }}</option>
    </b-select>
  </div>
</template>

<script>
import Vue from 'vue'
import { Select } from 'buefy'
Vue.use(Select)

export default {
  props: {
    categoryId: {
      type: String,
      required: true
    },
    namespace: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      localSelectedCategories: ''
    }
  },
  methods: {
    resetResults () {
      this.localSelectedCategories = ''
    },
    updateSelectedCategories () {
      const categoryObj = {
        categoryId: this.categoryId,
        categories: []
      }
      if (this.localSelectedCategories !== '') {
        categoryObj.categories = [this.localSelectedCategories]
      }
      this.$store.commit(
        this.namespace + '/UPDATE_SELECTED_CATEGORIES',
        categoryObj
      )
    }
  },
  computed: {
    categories () {
      const categories = this.$store.state[this.namespace].categories
      const filtered = categories.filter(
        item =>
          item.groupId === parseInt(this.categoryId) // &&
          // item.relatedEntries.totalCount > 0
      )
      const arr = []
      filtered.forEach(element => {
        arr.push(element)
      })
      return arr
    }
  },
  watch: {
    localSelectedCategories () {
      this.updateSelectedCategories()
    }
  },
  mounted () {
    this.updateSelectedCategories()
    const params = {}
    location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        params[item.split('=')[0]] = item.split('=')[1]
      })
    if (params.building) {
      this.localSelectedCategories = params.building
    }
  }
}
</script>
